import $ from 'jquery';
import '@fontsource-variable/dm-sans';
import '@fontsource-variable/dm-sans/opsz.css';
import '@fontsource-variable/dm-sans/opsz-italic.css';
import '@fontsource-variable/dm-sans/wght-italic.css';

import LangSelector from './components/lang-selector';
import SiteHeader from './components/site-header';
import NewsletterForm from './components/newsletter-form';
import ScrollInView from './components/scroll-in-view';

import DeviceManager from './utils/device-manager';
import SubMenu from './components/sub-menu';
import { Lightbox } from './components/lightbox';
import { AccordionDef } from './components/accordion';
import './components/handle-menu.js';
import { launchEmbla } from './components/launch-embla';
import { buttonsEffect } from './components/buttonsEffect';

// (function ($) {
// window.$ = $;

$(function () {
  const bootstrapApp = () => {
    const $html = $('html');

    // Touch device detection
    if (DeviceManager.isHandheld()) {
      $html.addClass('touch');

      if (DeviceManager.isIos()) {
        $html.addClass('ios');
      }
    } else {
      $html.addClass('no-touch');
    }

    // IE detection
    if (DeviceManager.isIe11()) {
      $html.addClass('ie11');
    } else if (DeviceManager.isEdge()) {
      $html.addClass('edge');
    }
  };

  const instanciateComponents = () => {
    // General components
    const langSelector = new LangSelector($('.language-selector'));
    const siteHeader = new SiteHeader($('.site-header'), 20);

    // Home slider component

    // Newsletter form component
    const $newsletterFormElements = $('.footer-block.footer-block--newsletter-style');
    if ($newsletterFormElements.length) {
      $newsletterFormElements.each(function (index, el) {
        const newsletterForm = new NewsletterForm(el);
      });
    }

    // Scroll in view component
    const $scrollInViewElements = $('.scroll-in-view');
    if ($scrollInViewElements.length) {
      const scrollInView = new ScrollInView($scrollInViewElements);
    }
  };

  bootstrapApp();
  instanciateComponents();
});

const mainMenu = document.getElementById('main-menu');
const secondaryMenu = document.getElementById('secondary-menu');

if (mainMenu) {
  const menuItems = mainMenu.querySelectorAll('.menu-item');

  menuItems.forEach((item) => {
    const subMenu = item.querySelector('.sub-menu');
    if (subMenu) {
      new SubMenu(subMenu, item);
    }
  });
}

if (secondaryMenu) {
  const menuItems = secondaryMenu.querySelectorAll('.menu-item');

  menuItems.forEach((item) => {
    const subMenu = item.querySelector('.sub-menu');
    if (subMenu) {
      new SubMenu(subMenu, item);
    }
  });
}

const togglePrice = (selectedVariation) => {
  const price = document.querySelectorAll('.price-btn.btn');

  price.forEach((p) => {
    if (p.id === selectedVariation) {
      p.classList.add('active');
    } else {
      p.classList.remove('active');
    }
  });
};

const variationChoices = document.querySelector('.variation-choices');

if (variationChoices) {
  const variations = variationChoices.querySelectorAll('.btn');
  const selectForm = document.getElementById('format');
  const variationInput = document.querySelector('input[name="variation_id"]');

  variations.forEach((variation) => {
    if (variation.classList.contains('active')) {
      const selectedVariation = variation.getAttribute('data-target');
      variationInput.value = variation.getAttribute('data-id');
      selectForm.value = selectedVariation;
      togglePrice(selectedVariation);
    }

    variation.addEventListener('click', () => {
      const selectedVariation = variation.getAttribute('data-target');
      variationInput.value = variation.getAttribute('data-id');
      selectForm.value = selectedVariation;
      variations.forEach((btn) => btn.classList.remove('active'));
      variation.classList.add('active');
      togglePrice(selectedVariation);
    });
  });
}

const galleryLightboxSections = document.querySelectorAll('.section-gallery');

if (galleryLightboxSections.length > 0) {
  galleryLightboxSections.forEach((section) => {
    const galleryContainer = section.querySelector('.section-gallery__images');

    if (galleryContainer) {
      Lightbox.init(galleryContainer);
    }
  });
}

const accordion = document.querySelectorAll('.accordion');

if (accordion.length > 0) {
  accordion.forEach((item) => {
    new AccordionDef(item);
  });
}

const testimoniesSlider = document.querySelector('.testimonies-section__testimonies');

if (testimoniesSlider) {
  launchEmbla(testimoniesSlider);
}

const highlightsProductsSlider = document.querySelector('.highlighted-products__slider');

if (highlightsProductsSlider) {
  launchEmbla(highlightsProductsSlider);
}
const filters = document.querySelector('.woocommerce-shop .filters');

if (filters) {
  const filtersToggler = filters.querySelector('.filters__header');

  filtersToggler.addEventListener('click', () => {
    filters.classList.toggle('active');
  });
}

const filterForm = document.getElementById('filter-products-form');

if (filterForm) {
  filterForm.addEventListener('submit', function (e) {
    e.preventDefault();

    const formData = new FormData(filterForm);
    const params = new URLSearchParams();

    const groupedData = {};

    for (const [key, value] of formData.entries()) {
      if (!groupedData[key]) {
        groupedData[key] = [];
      }

      if (value !== '') {
        groupedData[key].push(value);
      }
    }

    for (const key in groupedData) {
      if (groupedData[key].length > 0) {
        params.set(key, groupedData[key].join(','));
      }
    }

    let baseUrl = filterForm.action.split('?')[0];
    baseUrl = baseUrl.replace(/\/page\/\d+/g, '');
    const queryString = params.toString();

    window.location.href = queryString ? `${baseUrl}?${queryString}` : baseUrl;
  });
}

const orderForm = document.getElementById('order-by');

if (orderForm) {
  const selectElement = orderForm.querySelector('select');

  orderForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const formData = new FormData(orderForm);
    const params = new URLSearchParams(window.location.search);

    // Group values by name
    const groupedData = {};
    for (const [key, value] of formData.entries()) {
      if (!groupedData[key]) {
        groupedData[key] = [];
      }
      groupedData[key].push(value);
    }

    // Construct query string
    for (const key in groupedData) {
      params.append(key, groupedData[key].join(','));
    }

    // Redirect
    window.location.href = orderForm.action.split('?')[0] + '?' + params.toString();
  });

  selectElement.addEventListener('change', (e) => {
    e.preventDefault();
    const params = new URLSearchParams(window.location.search);
    params.set('order', selectElement.value);
    window.location.href = window.location.pathname + '?' + params.toString();
  });
}

const woocommerceNoticesWrapper = document.querySelector('.woocommerce-notices-wrapper');
const woocommerceInfo = document.querySelector('.woocommerce-info');

if (woocommerceNoticesWrapper) {
  if (woocommerceNoticesWrapper.children.length > 0) {
    woocommerceNoticesWrapper.classList.add('has-children');
  }
}

if (woocommerceInfo) {
  if (woocommerceInfo.children.length > 0) {
    woocommerceInfo.classList.add('has-children');
  }
}

const buttons = document.querySelectorAll('.button');
const btns = document.querySelectorAll('.btn:not(.price-btn)');

if (buttons.length > 0) {
  buttonsEffect(buttons);
}

if (btns.length > 0) {
  buttonsEffect(btns);
}

setTimeout(() => {
  const wooButtons = document.querySelectorAll('.wc-block-components-button');

  if (wooButtons.length > 0) {
    buttonsEffect(wooButtons);
  }
}, 800);

const getHeaderOffset = () => {
  const header = document.querySelector('.site-header');
  if (!header) return 0;

  return header.offsetHeight;
};

const scrollToElementWithOffeset = (element) => {
  const headerOffset = getHeaderOffset();

  const gap = 12; // Additional gap
  const targetTop = element.getBoundingClientRect().top + window.scrollY;
  const y = Math.max(0, targetTop - headerOffset - element.offsetHeight - gap);

  window.scrollTo({ top: y, behavior: 'smooth' });

  window.setTimeout(() => {
    const headerOffset2 = getHeaderOffset();
    const targetTop2 = element.getBoundingClientRect().top + window.scrollY;
    const y2 = Math.max(0, targetTop2 - headerOffset2 - element.offsetHeight - gap);

    if (Math.abs(window.scrollY - y2) > 2) {
      window.scrollTo({ top: y2, behavior: 'smooth' });
    }
  }, 250);
};

const heroBannerIndication = document.querySelector('.hero-banner__indications');
const highlightedProductsSection = document.querySelector(
  '.front__highlighted-products .container'
);

if (heroBannerIndication && highlightedProductsSection) {
  heroBannerIndication.addEventListener('click', () => {
    scrollToElementWithOffeset(highlightedProductsSection);
  });
}
